import type { Preset } from '@primeuix/themes/types';
import type { AuraBaseDesignTokens } from '@primeuix/themes/aura/base';

import { primitive as legacyPrimitive, semantic as legacySemantic } from './theme/tokens/basetokens-legacy';
import { legacyUtility } from './theme/tokens/utility-legacy';
import { presetComponents } from './cleverly-preset';

// Frozen component tokens (state before the brand-guide sync, decision log §8):
// these components were restyled to the guide in the shared layer, so the
// legacy theme mounts its own copies to stay pixel-identical.
import legacyBadge from './theme/components/legacy/badge';
import legacyButton from './theme/components/legacy/button';
import legacyCard from './theme/components/legacy/card';
import legacyDatatable from './theme/components/legacy/datatable';
import legacyMessage from './theme/components/legacy/message';
import legacyPassword from './theme/components/legacy/password';
import legacyProgressspinner from './theme/components/legacy/progressspinner';
import legacyTabs from './theme/components/legacy/tabs';
import legacyTag from './theme/components/legacy/tag';
import legacyToast from './theme/components/legacy/toast';

// The "old cleverly" theme (pre-rebrand blue brand, #35ABE2): the palette from
// git 49300725a^ mounted with the SAME component-token layer as the current
// Cleverly preset (minus the frozen overrides above), so both themes are
// drop-in interchangeable at runtime.
const legacyBase = {
    primitive: legacyPrimitive,
    semantic: legacySemantic
};

export default {
    ...legacyBase,
    components: {
        ...presetComponents,
        badge: legacyBadge,
        button: legacyButton,
        card: legacyCard,
        datatable: legacyDatatable,
        message: legacyMessage,
        password: legacyPassword,
        progressspinner: legacyProgressspinner,
        tabs: legacyTabs,
        tag: legacyTag,
        toast: legacyToast
    },
    extend: legacyUtility
} satisfies Preset<AuraBaseDesignTokens>;
